import styled, { css } from 'styled-components';

export const Style = {
  SpinnerContainer: styled('div')(() => css`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `),
  UnauthorizedContainer: styled('div')(({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacing.s4};
    width: 100%;
    height: 100%;
    padding: ${theme.spacing.s8} ${theme.spacing.s6};
    text-align: center;
    background-color: ${theme.palette.N650};
  `),
  UnauthorizedTitle: styled('h1')(({ theme }) => css`
    ${theme.typography.H4};
    font-weight: 600;
    color: ${theme.palette.N50};
    margin: 0;
  `),
  UnauthorizedBody: styled('p')(({ theme }) => css`
    ${theme.typography.Body1};
    color: ${theme.palette.N200};
    margin: 0;
    max-width: 480px;
  `),
  BackToHomepageLink: styled('a')(({ theme }) => css`
    ${theme.typography.Body2};
    color: ${theme.palette.ACYPrimaryMainLight};
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      opacity: 0.85;
    }
  `),
  TableLoadingContainer: styled('div')(() => css`
    position: relative;

    .MuiTableContainer-root {
      overflow-x: auto;
    }

    table {
      width: max-content;
      min-width: 100%;
    }
  `),
  TableLoadingOverlay: styled('div')(() => css`
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.6);
    pointer-events: all;
    cursor: wait;
  `)
};
